import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';

const initialState = {
    loadingStatus: null,
    data: null,
    error: null
};

export function UpdateFirmwareReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.UPDATE_FIRMWARE_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            } else {
                return state;
            }
        case actionTypes.CLEAR_STORE:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
